import React, { useEffect } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import GlobalClassFile from "../popups/GlobalClassFile";
import Debug from "./Debug";
import EmployeeLogin from "../popups/EmployeeLogin";
import Setup from "../popups/Setup";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import InventoryController from "./InventoryController";
import { createScreen } from "../hooks/createScreen";
import DocumentationController from "./DocumentationController";
import { createEmpty } from "../hooks/createEmpty";
import InventorySearch from "../popups/InventorySearch";

export default function GlobalController(props) {

    const { signal = {}, WS_ONLY = false, controller = "", setController = () => { } } = props;


    const drawInventory = () => {
        if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
            return;
        }
        const origin = window.bm_state.value;
        createScreen({
            signal: signal,
            component: <InventoryController controller={controller} flag="global" is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = origin;
            }
        });

    }


    const drawProductSearch = () => {

       

        if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
            return;
        }

        const origin = window.bm_state.value;
        const origin_controller =  window.ac;
        window.ac = "global";

        window.bm_state.value = ROUTES.INVENTORY.SEARCH
        createModal({
            component: <InventorySearch controller={controller} setStock={() => { }} selected={{}} route={ROUTES.INVENTORY.SEARCH} />, closable: true, title: "Product Search",
            callback: (e, _searchMsg) => {
                // Manual close
                if (!e) {
                    window.bm_state.value = origin;
                    window.ac = origin_controller; 
                    return;
                } else {
                    window.bm_state.value = ROUTES.INVENTORY.INVENTORY
                    createScreen({
                        signal: signal,
                        component: <InventoryController controller={controller} search={{ results: e, message: _searchMsg }} is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
                        callback: (_obj) => {
                            window.bm_state.value = origin;
                            window.ac = origin_controller; 
                        }
                    });
                }

                return;






                // return drawInventory()




                // setTimeout(() => {

                //     window.bm_state.value = ROUTES.INVENTORY.INVENTORY;
                //      createScreen({
                //     signal: signal,
                //     component: <InventoryController search={{ results: e, message: _searchMsg }} is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
                //     callback: (_obj) => {
                //         window.bm_state.value = origin;
                //     }
                // });

                // }, 0)





                // const { type = "", message = "", term = "" } = (e) ? e : {};

                // if (message) {
                //     setSearchMsg(message)
                // }


                // if (type !== "title_link") {
                //     setIsTitleLink(false);
                // }

                // switch (type.toLowerCase()) {

                //     case "title_link":
                //         setAlign("start");
                //         setFilters({ ...filters, "dynamic": false, "sort": "id", type: "title_link" })
                //         setData(e.data);
                //         setSelected(e.data.length > 0 ? e.data[0] : {});
                //         setIsTitleLink(true);
                //         break;

                //     case "keyword":
                //         keywordTerm.current = term;
                //         setFilters({ ...filters, "dynamic": false, "sort": "id", localSort: "init", type: "keyword" })
                //         setData(e.data.rows);
                //         setSelected(e.data.rows.length > 0 ? e.data.rows[0] : {})
                //         break;
                //     case "title":
                //         if (e.data.rows_previous.length > 0) { setAlign("start"); }
                //         setFilters({ ...filters, "sort": "title", "dynamic": true, type: "title" })
                //         setData(e.data.rows_previous.concat(e.data.rows_next));
                //         setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                //         break;
                //     case "isbn":
                //         if (e.data.rows_previous.length > 0) { setAlign("start"); }
                //         setFilters({ ...filters, "sort": "isbn", "dynamic": true, type: "isbn" })
                //         setData(e.data.rows_previous.concat(e.data.rows_next));
                //         setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                //         break;
                //     case "author":
                //         if (e.data.rows_previous.length > 0) { setAlign("start"); }
                //         setFilters({ ...filters, "sort": "author", "dynamic": true, type: "author" })
                //         setData(e.data.rows_previous.concat(e.data.rows_next));
                //         setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                //         break;
                //     case "supplier":
                //         if (e.data.rows_previous.length > 0) { setAlign("start"); }
                //         setFilters({ ...filters, "sort": "supplier", "dynamic": true, type: "supplier" })
                //         setData(e.data.rows_previous.concat(e.data.rows_next));
                //         setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                //         break;
                //     case "class":
                //         if (e.data.rows_previous.length > 0) { setAlign("start"); }
                //         setFilters({ ...filters, "sort": "class", "dynamic": true, type: "class" })
                //         setData(e.data.rows_previous.concat(e.data.rows_next));
                //         setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                //         break;
                //     case "upc":
                //         if (e.data.rows_previous.length > 0) { setAlign("start"); }
                //         setFilters({ ...filters, "sort": "upc", "dynamic": true, type: "upc" })
                //         setData(e.data.rows_previous.concat(e.data.rows_next));
                //         setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                //         break;
                // }


            }
        });



    }


    const drawClassFile = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.CLASSFILE;
        createModal({
            component: <GlobalClassFile controller={controller} route={ROUTES.GLOBAL.CLASSFILE} />, closable: true, title: "Classification File", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawDebug = () => {

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.CLASSFILE;
        createModal({
            component: <Debug controller={controller} route={ROUTES.GLOBAL.CLASSFILE} />, closable: true, title: "Debug", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawLogin = () => {

        // Logout if already logged in
        if (signal?.value?.session?.clerk_code) {
            pubCall("employee.logout", {}, (_s, _r) => {
                if (_s) {
                    signal.value = { ...signal.value, "session": _r }
                    showMessage("Active user has been logged out.")
                } else {
                    showError(_r);
                }
            })
            return;
        }

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.EMPLOYEE_LOGIN;
        createModal({
            component: <EmployeeLogin controller={controller} signal={signal} route={ROUTES.GLOBAL.EMPLOYEE_LOGIN} />, closable: true, title: "Login", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawSetup = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP;
        createModal({
            component: <Setup controller={controller} signal={signal} route={ROUTES.GLOBAL.SETUP} />, closable: true, title: "Setup Options", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }


    const drawDocs = () => {

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP;
        createEmpty({
            component: <DocumentationController controller={controller} signal={signal} route={ROUTES.GLOBAL.DOCS} />, closable: true, title: "Docs", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    useEffect(() => {

        const actions = [

            { key: KBD.F1, action: (e) => { drawDebug() } },
            { key: KBD.F2, action: (e) => { if (!WS_ONLY) { drawProductSearch() } } },
            { key: KBD.F4, action: (e) => { drawClassFile() } },
            { key: KBD.F6, action: (e) => { drawLogin() } },
            { key: KBD.F8, action: (e) => { drawDocs() } },
            //  { key: KBD.F5, action: (e) => { drawLogin() } },
            { key: KBD.ALT_S, action: (e) => { drawSetup() } },


        ];
        const cleanup = listen("", ROUTES.GLOBAL.GLOBAL, actions, false);
        return cleanup;
    }, []);



    return (<></>)
}